import { splitTestActions } from 'wanderu-ducks-split-test';
import { actionDuckUtils } from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';

import { actions as newRoutesActions } from '../../appstate/newRoutes';
import { actions as placeGuideActions } from '../../appstate/placeGuide';
import { getNewRoutes } from '../../services/seoService';
import SLICE_NAMESPACE from '../../types';

const logger = Logger.getLogger('fetchNewRoutes');

const NAMESPACE = 'ACTIONS/FETCH_NEW_C2C';

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(NAMESPACE, SLICE_NAMESPACE);

function fetchNewRoutes(localeAwareNewRoutesId, locale) {
    return async (dispatch) => {
        let error = null;

        dispatch(actions.startWork(localeAwareNewRoutesId));
        try {
            const { result } = await getNewRoutes(locale);
            dispatch(newRoutesActions.setNewRouteLinks(result, localeAwareNewRoutesId));
        } catch (ex) {
            logger.error('fetch', ex, {
                locale,
                localeAwareNewRoutesId,
            });

            error = {
                code: ex.code,
                message: 'set new c2c failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(localeAwareNewRoutesId, undefined, error));
        }
    };
}

const fetchNewRoutesSelectors = {
    ...selectors,
    selectNotFound(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && opStatus.error.code === 'INVALID_CITY_GUIDE';
    },
};

const fetchNewRoutesAction = {
    fetchNewRoutes,
    ...fetchNewRoutesSelectors,
};

export {
    fetchNewRoutesAction,
    NAMESPACE as namespace,
};

export default {
    [NAMESPACE]: reducer,
};
